import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { WorkTypeRecord } from '../entities/records';
import * as selectors from '../entities/WorkType/selectors';

function mapStateToProps(state, { workTypeId }) {
  return {
    workType: selectors.workTypeById(state, workTypeId),
  };
}

export default compose(
  setPropTypes({
    workTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    workType: PropTypes.instanceOf(WorkTypeRecord),
  }),
)(mapStateToProps);
